import { render, staticRenderFns } from "./ProductIconPopupIframe.vue?vue&type=template&id=68a54b5e&"
import script from "./ProductIconPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductIconPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports